<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <div class="input-group-text"> {{ prefix }} </div>
    </div>
    <input
      id="mobile_phone_number"
      name="mobile_phone_number"
      type="text"
      class="form-control"
      required=""
      autofocus=""
      v-model="phone"
      size="10"
      maxlength="8"
    >
  </div>
</template>
<script>
export default {
  name: "InputPhoneComponent",
  props: {
    prefix: {
      type: String,
      default: "+47"
    },
    modelValue: {
      type: String,
      default: "",
    }
  },
  emits: ['update:modelValue'],
  computed: {
    phone: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>
.phone-box {
  display: block;
  align-items: center;
  border: 1px solid #a0a0a0;
  border-radius: 4px;
  width: 135px;
}

.phone-box .prefix {
  background-color: #eeeeee;
  padding: 3px 5px;
  font-weight: 500;
  display: inline-block;
}

.phone-box input {
  border: none;
  outline: none;
  display: inline-flex;
}

.phone-box:focus-within {
  border-color: #4f7df3;
}
</style>
